import React from 'react';

import { CardBack } from '../../../../components/card/card-back';
import { CardFront } from '../../../../components/card/card-front';
import { FlipCard } from '../../../../components/flip-card/flip-card';
import { Text } from '../../../../components/text/text';
import { Translate } from '../../../../components/translate';
import { CARD_CONFIG } from '../../constants/card-config';
import { CARD_7, CARD_8, CARD_9 } from '../../constants/card-ids';

const CardEight: React.FC = () => {
  const { label, labelColor, title, icon, backfaceIconSRC } = CARD_CONFIG[CARD_8];

  return (
    <FlipCard
      cardId={CARD_8}
      frontContent={<CardFront title={title} label={label} labelColor={labelColor} icon={icon} />}
      backContent={
        <CardBack
          label={label}
          labelColor={labelColor}
          title={title}
          backfaceIconSRC={backfaceIconSRC}
          previousCardId={CARD_7}
          nextCardId={CARD_9}
        >
          <Text fontFamily="roboto">
            <Translate id="translate.cards.lesson.eight.text" />
          </Text>
        </CardBack>
      }
    />
  );
};

export default CardEight;
